export default __webpack_public_path__ + "static/media/dots.8244b8fb.svg";